import { registerClientReference } from "react-server-dom-turbopack/server.edge";
export const CartProvider = registerClientReference(
    function() { throw new Error("Attempted to call CartProvider() from the server but CartProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/app/context/CartContext.tsx",
    "CartProvider",
);
export const useCart = registerClientReference(
    function() { throw new Error("Attempted to call useCart() from the server but useCart is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/app/context/CartContext.tsx",
    "useCart",
);
